'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useEffect, useState } from 'react';
import { useParams, usePathname } from 'next/navigation';
import dayjs from '../utils/dayjs';
import useUtmTracking from '../hooks/useUtmTracking';
import useServiceWorker from '../hooks/useServiceWorker';

require('../utils/firebase');

const ClientWrapper = () => {
  const { locale } = useParams() as { locale: string };
  const pathname = usePathname();
  const [history, setHistory] = useState<string[]>([]);

  useEffect(() => {
    dayjs.locale(!locale || locale === 'nl' ? 'nl-be' : locale);
  }, [locale]);

  useUtmTracking();

  useServiceWorker();

  useEffect(() => {
    if (history[history.length - 1] !== pathname) setHistory((prev) => [...prev, pathname]);
  }, [pathname, history]);

  return null; // No UI, just logic
};

export default ClientWrapper;
